import styled from 'helpers/styles';
import {css} from 'styled-components';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MentionsInput} from 'react-mentions';
import utils from 'helpers/utils';
import constants from 'helpers/constants';
import {lighten} from 'polished';

const StyledMentionsInput = styled(MentionsInput)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--mentions-input-mention-color': lighten(0.1, props.theme.state2Color(props.$color, 'default', constants.colorTypes.base, constants.colorTargets.background)),
      '--mentions-input-min-height': utils.isDefined(props.$rows ?? props.$minRows) ?
        props.theme.layout((((props.$rows ?? props.$minRows) * 24) + (2 * 8))) : null,
      '--mentions-input-max-height': utils.isDefined(props.$rows ?? props.$maxRows) ?
        props.theme.layout((((props.$rows ?? props.$maxRows) * 24) + (2 * 8))) : null,
      '--mentions-input-dense-min-height': utils.isDefined(props.$rows ?? props.$minRows) ?
        props.theme.layout((((props.$rows ?? props.$minRows) * 22.5) + (2 * 6.5))) : null,
      '--mentions-input-dense-max-height': utils.isDefined(props.$rows ?? props.$maxRows) ?
        props.theme.layout((((props.$rows ?? props.$maxRows) * 22.5) + (2 * 6.5))) : null
    };

    return utils.styleProps(attr, vars);
  })`
  outline: none;
  font: inherit;
  
  * {
    outline: none;
    font: inherit;
  }
  
  .Mention {
    color: ${props => props.$css.$var('--mentions-input-mention-color')};
  }

  ${props => utils.isDefined(props.$rows ?? props.$minRows) ? css`
    > * > div, textarea {
      min-height: ${props => props.$css.$var('--mentions-input-min-height', false)};
    }
  ` : null}

  ${props => utils.isDefined(props.$rows ?? props.$maxRows) ? css`
    > * > div, textarea {
      max-height: ${props => props.$css.$var('--mentions-input-max-height', false)};
    }
  ` : null}
  
  > div {
    position: relative;
    > div:first-child {
      z-index: 1;
      pointer-events: none;
    }
  }
  
  textarea, input {
    border: unset;
  }

  .text-test {
    visibility: hidden;
    position: absolute;
    font: inherit;
  }
  
  .MentionsInput-size-smaller {
    ${props => utils.isDefined(props.$rows ?? props.$minRows) ? css`
      > * > div, textarea {
        min-height: ${props => props.$css.$var('--mentions-input-dense-min-height', false)};
      }
    ` : null}

    ${props => utils.isDefined(props.$rows ?? props.$maxRows) ? css`
      > * > div, textarea {
        max-height: ${props => props.$css.$var('--mentions-input-dense-max-height', false)};
      }
    ` : null}
  }
  
  ${ComponentStyles}
`;

StyledMentionsInput.propTypes = {
  theme: PropTypes.object
};

export default StyledMentionsInput;
